<template>
  <badge :type="getBadgeType()">
    {{ $t(`REQUESTS.REQUEST_STATUS_${request.status}`) }}
  </badge>
</template>

<script>
import {
  requestStatusesOption,
  REQUEST_STATUS_DRAFT,
  REQUEST_STATUS_ASSIGNED,
  REQUEST_STATUS_COMPLETED,
  REQUEST_STATUS_CANCELED,
} from "@/constants/requests";

export default {
  name: "request-status-badge",

  components: {},

  mixins: [],

  props: ["request"],

  data() {
    return {
      statusesOptions: requestStatusesOption,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.request.status) {
        case REQUEST_STATUS_DRAFT:
          return "primary";
        case REQUEST_STATUS_ASSIGNED:
          return "default";
        case REQUEST_STATUS_COMPLETED:
          return "success";
        case REQUEST_STATUS_CANCELED:
          return "danger";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
